module.exports = __webpack_public_path__ + "frontend/img/icon_female.2918ef03.svg";